var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle5, _circle6, _circle7, _path9, _path10, _circle8, _circle9, _rect, _circle10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle11, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 135,
    viewBox: "0 0 140 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.4375,
    cy: 66.87,
    r: 46.125,
    fill: "#FFD445"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3125,
    cy: 100.057,
    r: 14.0625,
    fill: "#FFD445"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.06,
    cy: 18.6,
    r: 11.16,
    fill: "#FFD445"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 113.557,
    r: 15.75,
    fill: "#FFD445"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.583 106.189L111.697 115.523L120.013 121.988L138.063 118.066L136.346 110.165L134.63 102.267L116.581 106.189H116.583Z",
    fill: "#CFD0DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.766 108.042L112.011 116.125L118.766 124.208H137.236V108.042H118.766ZM118.497 117.773C117.587 117.773 116.85 117.036 116.85 116.125C116.85 115.215 117.587 114.478 118.497 114.478C119.408 114.478 120.145 115.215 120.145 116.125C120.145 117.036 119.408 117.773 118.497 117.773Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.83 124.809H118.485L111.232 116.129L118.485 107.449H137.83V124.809ZM119.043 123.615H136.636V108.643H119.043L112.787 116.129L119.043 123.615ZM118.497 118.373C117.258 118.373 116.252 117.368 116.252 116.129C116.252 114.89 117.258 113.884 118.497 113.884C119.736 113.884 120.742 114.893 120.742 116.129C120.742 117.365 119.736 118.373 118.497 118.373ZM118.497 115.075C117.918 115.075 117.446 115.547 117.446 116.126C117.446 116.705 117.918 117.177 118.497 117.177C119.076 117.177 119.548 116.705 119.548 116.126C119.548 115.547 119.076 115.075 118.497 115.075Z",
    fill: "#282D33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.606 116.128C133.606 119.072 131.221 121.456 128.278 121.456C125.335 121.456 122.95 119.072 122.95 116.128C122.95 113.185 125.335 110.8 128.278 110.8C131.221 110.8 133.606 113.185 133.606 116.128Z",
    fill: "#FFD445"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.13 115.532H109.375V116.726H118.13V115.532Z",
    fill: "#282D33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.239 116.296C125.169 116.296 124.299 115.426 124.299 114.356C124.299 113.286 125.169 112.415 126.239 112.415C127.309 112.415 128.18 113.286 128.18 114.356C128.18 115.426 127.309 116.296 126.239 116.296ZM126.239 113.43C125.729 113.43 125.311 113.847 125.311 114.358C125.311 114.869 125.726 115.286 126.239 115.286C126.753 115.286 127.168 114.869 127.168 114.358C127.168 113.847 126.75 113.43 126.239 113.43Z",
    fill: "#282D33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.287 120.176C129.217 120.176 128.347 119.305 128.347 118.235C128.347 117.165 129.217 116.295 130.287 116.295C131.357 116.295 132.228 117.165 132.228 118.235C132.228 119.305 131.357 120.176 130.287 120.176ZM130.287 117.31C129.776 117.31 129.359 117.727 129.359 118.238C129.359 118.749 129.774 119.166 130.287 119.166C130.801 119.166 131.216 118.749 131.216 118.238C131.216 117.727 130.798 117.31 130.287 117.31Z",
    fill: "#282D33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.933 112.978L124.948 118.966L125.663 119.681L131.649 113.693L130.933 112.978Z",
    fill: "#282D33"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.4375,
    cy: 66.8699,
    r: 54,
    stroke: "#363853",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "8 8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5906,
    cy: 116.399,
    r: 3.40313,
    fill: "#FFD445"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.1875,
    cy: 124.245,
    r: 2.25,
    fill: "#FFD445"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.125 133.995C64.7138 133.995 66.8125 131.896 66.8125 129.308C66.8125 126.719 64.7138 124.62 62.125 124.62C59.5362 124.62 57.4375 126.719 57.4375 129.308C57.4375 131.896 59.5362 133.995 62.125 133.995ZM62.125 134.933C65.2316 134.933 67.75 132.414 67.75 129.308C67.75 126.201 65.2316 123.683 62.125 123.683C59.0184 123.683 56.5 126.201 56.5 129.308C56.5 132.414 59.0184 134.933 62.125 134.933Z",
    fill: "#FFD445"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5625 60.3076C10.1513 60.3076 12.25 58.2089 12.25 55.6201C12.25 53.0312 10.1513 50.9326 7.5625 50.9326C4.97367 50.9326 2.875 53.0312 2.875 55.6201C2.875 58.2089 4.97367 60.3076 7.5625 60.3076ZM7.5625 61.2451C10.6691 61.2451 13.1875 58.7267 13.1875 55.6201C13.1875 52.5135 10.6691 49.9951 7.5625 49.9951C4.4559 49.9951 1.9375 52.5135 1.9375 55.6201C1.9375 58.7267 4.4559 61.2451 7.5625 61.2451Z",
    fill: "#FFD445"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 60.1201,
    r: 2.25,
    fill: "#FFD445"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.5,
    cy: 2.25008,
    r: 2.25,
    fill: "#FFD445"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.0625,
    y: 39.3079,
    width: 6.75,
    height: 6.75,
    rx: 2,
    fill: "#FFD445"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.62458,
    cy: 35.7456,
    r: 9.37458,
    fill: "#FFD445"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62458 45.119C4.45497 45.119 0.25 40.914 0.25 35.7444C0.25 30.5748 4.45497 26.3698 9.62458 26.3698C14.7942 26.3698 18.9992 30.5748 18.9992 35.7444C18.9992 40.914 14.7942 45.119 9.62458 45.119ZM9.62458 27.8596C5.27808 27.8596 1.7398 31.3979 1.7398 35.7444C1.7398 40.0909 5.27808 43.6292 9.62458 43.6292C13.9711 43.6292 17.5094 40.0909 17.5094 35.7444C17.5094 31.3979 13.9711 27.8596 9.62458 27.8596Z",
    fill: "#363853"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62496 42.1398C13.1568 42.1398 16.0199 39.2767 16.0199 35.7449C16.0199 32.213 13.1568 29.3499 9.62496 29.3499C6.09311 29.3499 3.22998 32.213 3.22998 35.7449C3.22998 39.2767 6.09311 42.1398 9.62496 42.1398Z",
    fill: "#FABE00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2726 36.858L8.1124 36.0162C7.20362 35.4389 7.01367 34.7909 7.01367 34.3514V33.4463C7.01367 32.3029 7.9448 31.3718 9.08822 31.3718H10.1572C11.3006 31.3718 12.2317 32.3029 12.2317 33.4463V33.8709H10.7419V33.4463C10.7419 33.1223 10.4812 32.8616 10.1572 32.8616H9.08822C8.76419 32.8616 8.50347 33.126 8.50347 33.4463V34.3514C8.50347 34.3886 8.56679 34.5302 8.84985 34.7201L10.8015 35.4687L10.2689 36.8617L10.2726 36.858Z",
    fill: "#363853"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1572 40.2735H9.08822C7.9448 40.2735 7.01367 39.3424 7.01367 38.1989V37.7743H8.50347V38.1989C8.50347 38.523 8.76419 38.7837 9.08822 38.7837H10.1572C10.4775 38.7837 10.7419 38.523 10.7419 38.1989V37.2939C10.7419 37.2641 10.6749 37.1077 10.3695 36.9028L8.5072 36.1877L9.04353 34.7985L11.1106 35.6104C12.038 36.1989 12.2317 36.8544 12.2317 37.2976V38.2027C12.2317 39.3461 11.3006 40.2772 10.1572 40.2772V40.2735Z",
    fill: "#363853"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4512 30.2959H8.96143V32.281H10.4512V30.2959Z",
    fill: "#363853"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4512 39.2083H8.96143V41.1934H10.4512V39.2083Z",
    fill: "#363853"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1304 20.5337C34.5161 20.5301 32.9689 19.889 31.8275 18.7504C30.686 17.6119 30.0431 16.0688 30.0396 14.4587C30.0395 12.8463 30.6808 11.2997 31.8227 10.1583C32.9645 9.01683 34.5137 8.37379 36.1304 8.37021C37.7494 8.37021 39.302 9.01168 40.4468 10.1535C41.5916 11.2953 42.2347 12.8439 42.2347 14.4587C42.2311 16.0711 41.5864 17.6163 40.442 18.7552C39.2976 19.8941 37.747 20.5337 36.1304 20.5337ZM36.1304 11.0837C35.6849 11.0837 35.2437 11.1714 34.8323 11.3419C34.4209 11.5124 34.0473 11.7622 33.7329 12.077C33.4185 12.3918 33.1695 12.7655 33.0003 13.1765C32.831 13.5875 32.7448 14.0279 32.7466 14.4722C32.7466 15.3673 33.1031 16.2258 33.7377 16.8587C34.3723 17.4916 35.2329 17.8472 36.1304 17.8472C36.5759 17.849 37.0173 17.763 37.4294 17.5942C37.8416 17.4254 38.2162 17.1771 38.5318 16.8635C38.8475 16.5499 39.0979 16.1772 39.2688 15.7669C39.4397 15.3565 39.5277 14.9166 39.5277 14.4722C39.5295 14.0261 39.4429 13.584 39.273 13.1714C39.1031 12.7587 38.8531 12.3835 38.5374 12.0675C38.2218 11.7514 37.8467 11.5006 37.4336 11.3294C37.0205 11.1583 36.5777 11.0702 36.1304 11.0702V11.0837Z",
    fill: "#FFD445"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.8791,
    cy: 66.7941,
    r: 32.3996,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9997 101.37C50.9703 101.37 35.5449 85.9446 35.5449 66.9152C35.5449 47.8858 50.9703 32.4604 69.9997 32.4604C89.0291 32.4604 104.455 47.8858 104.455 66.9152C104.455 85.9446 89.0291 101.37 69.9997 101.37ZM69.9997 94.4791C77.3101 94.4791 84.3211 91.575 89.4903 86.4058C94.6596 81.2366 97.5636 74.2256 97.5636 66.9152C97.5636 59.6048 94.6596 52.5939 89.4903 47.4246C84.3211 42.2554 77.3101 39.3514 69.9997 39.3514C62.6894 39.3514 55.6784 42.2554 50.5092 47.4246C45.3399 52.5939 42.4359 59.6048 42.4359 66.9152C42.4359 74.2256 45.3399 81.2366 50.5092 86.4058C55.6784 91.575 62.6894 94.4791 69.9997 94.4791ZM66.5646 80.6971L51.9454 66.078L56.8173 61.2061L66.5646 70.9533L86.0522 51.4622L90.9276 56.3341L66.5646 80.6971Z",
    fill: "#363853"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCheck);
export default __webpack_public_path__ + "static/media/paymentCheck.18a5c0ed3d8271efacba89af5aa5b844.svg";
export { ForwardRef as ReactComponent };